import React, { Component } from 'react';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FAQ from '../Inc/FAQ';
import { Input, Button, message, Row, Form, Col, Card, Spin, Icon, Tooltip, Modal, Radio } from 'antd';
import { compose } from 'recompose';
import Skeleton from 'react-loading-skeleton';
import SearchAlumniFilter from '../Inc/SearchAlumniFilter';
import { history } from '../../container/History';
import { sendNesaMail } from '../../actions/index';

const { TextArea } = Input;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const FormItem = Form.Item;
const INDIVIDUAL_PURCHASE = JSON.parse(process.env.REACT_APP_INDIVIDUAL_PURCHASE);
let notes = ''
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};

class viewApplicationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            registrationid: 0,
            loading: false,
            MembershipName: '',
            notes: '',
            viewApplication: true,
            resending: false,
            selectedEmail: '',
            emailModalVisible: false,
            personProfileEmails: [], 
            modalEmails: [],
            allAPIsLoaded: false,   
        }
    }

    handleResendEmail = () => {
        const { record } = this.props;
        const { personProfileEmails } = this.state;

        let combinedEmails = [];

        if (record && record.email) {
            combinedEmails.push({ email: record.email, id: 'record-email' });
        }

        if (personProfileEmails && personProfileEmails.length > 0) {
            combinedEmails = combinedEmails.concat(personProfileEmails);
        }

        const uniqueEmails = [];
        const seen = new Set();

        combinedEmails.forEach(e => {
            if (!seen.has(e.email)) {
                seen.add(e.email);
                uniqueEmails.push(e);
            }
        });

        if (uniqueEmails.length === 0) {
            Modal.error({
                title: "Missing Email",
                content: "No email addresses available for this member.",
            });
            return;
        }

        this.setState({
            emailModalVisible: true,
            selectedEmail: uniqueEmails[0].email,
            modalEmails: uniqueEmails
        });
    };

    sendEmail = (email) => {
        const { record, sendNesaMail, paymentrecords } = this.props;
        this.setState({ resending: true });

        const payment = paymentrecords && paymentrecords.length > 0 ? paymentrecords[0] : null;

        const mailData = {
            memberId: Number(record.memberId),
            toGifter: false,
            email: email, 
            paragraph1: INDIVIDUAL_PURCHASE.PARAGRAPH1,
            paragraph2: INDIVIDUAL_PURCHASE.PARAGRAPH2,
            paragraph3: INDIVIDUAL_PURCHASE.PARAGRAPH3,
            paragraph4: INDIVIDUAL_PURCHASE.PARAGRAPH4,
            paragraph5: INDIVIDUAL_PURCHASE.PARAGRAPH5,
            MembershipType: record.alumniMembershipLevelId == 30 ? "NESA 5Year" : "NESA Lifetime",
            transactionId: payment ? payment.paymentTransactionId : "-",
        };

        sendNesaMail(mailData)
            .then(() => {
                Modal.success({
                    title: "Email Sent",
                    content: (
                        <span>
                            Confirmation email has been resent to <b>{email}</b>.
                        </span>
                    ),
                });
            })
            .catch((error) => {
                const errorCode = error.errorCode || "";
                const errorMessage = error.message || "Error";
                const errorDesc =
                    error.errorDesc ||
                    "Failed to resend confirmation email. Please try again.";

                Modal.error({
                    title: `${errorCode} ${errorMessage}`.trim(),
                    content: errorDesc,
                });
            })
            .finally(() => {
                this.setState({ resending: false, emailModalVisible: false });
            });
    };

    handleEmailChange = (e) => {
        this.setState({
            selectedEmail: e.target.value,
            manualEmail: e.target.value === "manual" ? this.state.manualEmail : "",
        });
    };

    confirmEmailResend = () => {
        const { selectedEmail, manualEmail } = this.state;
        const emailToSend = selectedEmail === "manual" ? manualEmail : selectedEmail;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailToSend || !emailRegex.test(emailToSend)) {
            Modal.error({
                title: "Invalid Email",
                content: "Please enter a valid email address before sending.",
            });
            return;
        }

        this.sendEmail(emailToSend);
    };

    cancelEmailModal = () => {
        this.setState({ emailModalVisible: false });
    };

    componentWillReceiveProps = (nextprops) => {
        if (this.props.registrationID !== nextprops.registrationID) {
            this.props.actions.getPendingMembershipRecord(nextprops.registrationID)
            this.props.actions.getPendingMembershipRecordPayment(nextprops.registrationID)
            this.props.actions.getRegistrationNotes(nextprops.registrationID)
            this.setState({
                registrationid: nextprops.registrationID,
                MembershipName: ''
            })
        }
    }

    componentDidMount = () => {
        if (this.props.registrationID) {
            this.props.actions.getPendingMembershipRecord(this.props.registrationID)
            this.props.actions.getPendingMembershipRecordPayment(this.props.registrationID)
            this.props.actions.getRegistrationNotes(this.props.registrationID)
            if (this.state.registrationid == 0) {
                this.setState({
                    registrationid: parseInt(this.props.registrationID),
                    MembershipName: ''
                })
            }
        }
        this.props.actions.getNESAmembershiplevels()
        this.props.actions.getSAFmembershiplevels()
        this.props.actions.getStates()
    }

    componentDidUpdate(prevProps) {
        const { record, personProfile } = this.props;

        if (prevProps.registrationID !== this.props.registrationID) {
            this.setState({ allAPIsLoaded: false });
            return;
        }

        if (
            record &&
            record.memberId &&
            (!prevProps.record || prevProps.record.memberId !== record.memberId)
        ) {
            this.setState({ allAPIsLoaded: false }); 
            const { firstName, lastName, memberId } = record;
            this.props.actions.globalSearch({
                scout_first_name: firstName,
                scout_last_name: lastName,
                scout_member_id: memberId,
            });
        }

        const recordReady = record && record.memberId;
        const profileReady = personProfile && Array.isArray(personProfile.emails);

        if (!this.state.allAPIsLoaded && recordReady && profileReady) {
            this.setState({ allAPIsLoaded: true });
        }

        if (prevProps.personProfile !== personProfile && profileReady) {
            const emails = personProfile.emails.map(e => ({
                email: e.email,
                id: e.id,
                isPrimary: e.isPrimary,
            }));
            this.setState({ personProfileEmails: emails });
        }
    }

    states = () => {
        if (this.props.allstates) {
            let statesarray = this.props.allstates
            return statesarray.map((k, index) => {
                return (
                    <option key={index} value={k.id}>{k.short}</option>
                )
            })
        }
    }

    addnotesvalue = (e) => {
        notes = e.target.value
        this.setState({
            notes: e.target.value
        })
    }

    showApplcation = (value) => {
        this.setState({
            viewApplication: value
        })
    }

    updateNotes = () => {
        if (notes == '') {
            message.error('Note Field is Empty!', 3)
        } else {
            this.props.actions.membershipNotes(notes, this.state.registrationid)
        }
    }

    getMembershipName = (applicationType) => {
        if (this.props.nesa_levels && this.props.record && this.props.saflevels) {
            if (applicationType == "Alumni") {
                let saflevels = this.props.saflevels
                saflevels.map((k, index) => {
                    if (parseInt(k.id) === this.props.record.alumniMembershipLevelId) {
                        if (this.state.MembershipName == '') {
                            this.setState({
                                MembershipName: k.name
                            })
                        }
                    }
                })
            } else {
                let nesalevels = this.props.nesa_levels
                nesalevels.map((k, index) => {
                    if (parseInt(k.id) === this.props.record.alumniMembershipLevelId) {
                        if (this.state.MembershipName == '') {
                            this.setState({
                                MembershipName: k.name
                            })
                        }
                    }
                })
            }
        }
    }

    RenderRecords = () => {
        if (this.props.record && this.props.notes) {
            //if (this.props.record) {

            // let notesArray = this.props.notes
            // let recentNote = ""
            // let noteIndex = notesArray.length - 1
            // if (noteIndex != -1) {
            //     recentNote = notesArray[noteIndex].note
            //     notes = recentNote
            // }

            const notesArray = this.props.notes || [];

            let recentNote = "";

            const latestUserNote = [...notesArray]
                .reverse()
                .find(note => !note.isSystemGenerated);

            if (latestUserNote) {
                recentNote = latestUserNote.note;
            } else if (notesArray.length > 0) {
                recentNote = notesArray[notesArray.length - 1].note;
            }

            notes = recentNote;

            this.getMembershipName(this.props.record.applicationType)
            let shippingaddress = {}
            if (!this.props.record.parentGuardianInfo.shipToSelf) {
                shippingaddress.firstname = this.props.record.firstName
                shippingaddress.lastname = this.props.record.lastName
                shippingaddress.addline1 = this.props.record.addressLine1
                shippingaddress.addline2 = this.props.record.addressLine2
                shippingaddress.addline3 = this.props.record.addressLine3 ? this.props.record.addressLine3 : ''
                shippingaddress.city = this.props.record.city
                shippingaddress.state = this.props.record.state
                shippingaddress.country = this.props.record.country
                shippingaddress.zipcode = this.props.record.zip
                shippingaddress.phone = this.props.record.phoneCountryId + this.props.record.areaCode + this.props.record.lineNumber
                shippingaddress.email = this.props.record.email
            } else {
                shippingaddress.firstname = this.props.record.parentGuardianInfo.firstName
                shippingaddress.lastname = this.props.record.parentGuardianInfo.lastName
                shippingaddress.addline1 = this.props.record.parentGuardianInfo.addressLine1
                shippingaddress.addline2 = this.props.record.parentGuardianInfo.addressLine2
                shippingaddress.addline3 = this.props.record.parentGuardianInfo.addressLine3 ? this.props.record.parentGuardianInfo.addressLine3 : ''
                shippingaddress.city = this.props.record.parentGuardianInfo.city
                shippingaddress.state = this.props.record.parentGuardianInfo.state
                shippingaddress.country = this.props.record.parentGuardianInfo.country
                shippingaddress.zipcode = this.props.record.parentGuardianInfo.zip
                shippingaddress.phone = this.props.record.parentGuardianInfo.phoneCountryId + this.props.record.parentGuardianInfo.areaCode + this.props.record.parentGuardianInfo.lineNumber
                shippingaddress.email = this.props.record.parentGuardianInfo.email
            }
            const { getFieldDecorator } = this.props.form;
            return (
                <Row gutter={48} className="merbership-field-container">
                    {this.state.viewApplication &&
                        <div>
                            <div className="membership-heading"><h4>MEMBERSHIP INFORMATION</h4><hr /></div>
                            <Row className="membeship-panel">
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'> Membership: </label>
                                        <label className='membership-field-value'>
                                        {this.props.record.alumniMembershipLevelId == 30 && <span>NESA 5 Yrs</span>} 
                                        {this.props.record.alumniMembershipLevelId == 32 && <span>NESA Lifetime</span>}
                                        </label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'> Amount Paid: </label>
                                        <label className='membership-field-value'> $ {this.props.record.totalAmountPaid} </label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'> Is Rush: </label>
                                        <label className='membership-field-value'>{this.props.record.isRush ? "YES" : "NO"} </label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'> TransactionID: </label>
                                        <label className='font-12 membership-field-value'>{this.props.paymentrecords? this.props.paymentrecords.length != 0 ? this.props.paymentrecords[0].paymentTransactionId : "-" : "-"}  </label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'> Applicant ID: </label>
                                        <label className='membership-field-value'>{this.props.record.applicantId} </label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'> Application Date: </label>
                                        <label className='membership-field-value'>{this.props.record.applicationDate}</label>
                                    </Col>
                                </Row>
                            </Row>
                            <div className="membership-heading"><h4>ALUMNI INFORMATION</h4><hr /></div>
                            <Row className="membeship-panel">
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Member ID: </label>
                                        <label className='membership-field-value'>{this.props.record.memberId}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  First Name:  </label>
                                        <label className='membership-field-value'>{this.props.record.firstName}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Middle Name:  </label>
                                        <label className='membership-field-value'>{this.props.record.middleName}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Last Name:  </label>
                                        <label className='membership-field-value'>{this.props.record.lastName}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Date of Birth:  </label>
                                        <label className='membership-field-value'>{this.props.record.dateOfBirth}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Age:  </label>
                                        <label className='membership-field-value'>{this.props.record.age}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Gender:  </label>
                                        <label className='membership-field-value'>{this.props.record.gender}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Ethnic:  </label>
                                        <label className='membership-field-value'>{this.props.record.ethnicBackground}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Phone:  </label>
                                        <label className='membership-field-value'>{this.props.record.phoneCountryId + this.props.record.areaCode + this.props.record.lineNumber}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Email:  </label>
                                        <label className='membership-field-value'>{this.props.record.email}</label>
                                    </Col>
                                </Row>
                            </Row>
                            <div className="membership-heading"><h4>EAGLE INFORMATION</h4><hr /></div>
                            <Row className="membeship-panel">
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Board Review Date:  </label>
                                        <label className='membership-field-value'>{this.props.record.boardReviewDate}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Eagle Unit Number:  </label>
                                        <label className='membership-field-value'>{this.props.record.eagleUnitNumber}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Eagle Scout City:  </label>
                                        <label className='membership-field-value'>{this.props.record.eagleScoutCity}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Eagle Scout State:  </label>
                                        <label className='membership-field-value'>{this.props.record.eagleScoutState}</label>
                                    </Col>
                                </Row>
                            </Row>
                            <div className="membership-heading"><h4>SHIPPING INFORMATION</h4><hr /></div>
                            <Row className="membeship-panel">
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  First Name:  </label>
                                        <label className='membership-field-value'>{shippingaddress.firstname}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Last Name:  </label>
                                        <label className='membership-field-value'>{shippingaddress.lastname}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Address Line 1:  </label>
                                        <label className='membership-field-value'>{shippingaddress.addline1}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Address Line 2:  </label>
                                        <label className='membership-field-value'>{shippingaddress.addline2}</label>
                                    </Col>
                                </Row>
                                {shippingaddress.country.toLowerCase() == "usa" ? 
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  City:  </label>
                                        <label className='membership-field-value'>{shippingaddress.city}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  State:  </label>
                                        <label className='membership-field-value'>{shippingaddress.state}</label>
                                    </Col>
                                </Row> : 
                                <Row type='flex' align='middle'>
                                <Col span={10}>
                                        <label className='membership-field-label'>  Address Line 3:  </label>
                                        <label className='membership-field-value'>{shippingaddress.addline3}</label>
                                </Col>
                                <Col span={10}>
                                        <label className='membership-field-label'>  Country:  </label>
                                        <label className='membership-field-value'>{shippingaddress.country}</label>
                                    </Col>
                            </Row>
                    }
                                {shippingaddress.country.toLowerCase() == "usa" ?  <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Country:  </label>
                                        <label className='membership-field-value'>{shippingaddress.country}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  ZIP Code:  </label>
                                        <label className='membership-field-value'>{shippingaddress.zipcode}</label>
                                    </Col>
                                </Row>
                            :   ""
                            }
                                
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Phone:  </label>
                                        <label className='membership-field-value'>{shippingaddress.phone}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Email:  </label>
                                        <label className='membership-field-value'>{shippingaddress.email}</label>
                                    </Col>
                                </Row>
                            </Row>
                            <div className="membership-heading"><h4>NOTES</h4><hr /></div>
                            <Row type="flex" className='member-id-container notes-row' justify="center" align="bottom">
                                <Col span={24}>
                                    <FormItem
                                    >
                                        {getFieldDecorator('notes', {
                                            initialValue: recentNote ? recentNote : "",
                                            rules: [{ required: false }],
                                        })(
                                            <TextArea
                                                value={recentNote}
                                                placeholder=""
                                                onChange={this.addnotesvalue}
                                                autosize={{ minRows: 4, maxRows: 6 }}
                                                style={{ width: '100%' }}
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>
                        </div>
                    }
                </Row >
            )
        }
        return <Row>
            <Col span={24}>
                <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Membership Information..." />
            </Col>
        </Row>
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { emailModalVisible, selectedEmail, resending } = this.state;

        return (
            <div>
                <Row className='membership-activate-panel padding-0' type='flex' align='middle' justify='space-between'>
                    <Row type="flex" justify="center" align="center">
                        <Col className="" span={24}>
                            <div
                                className="centered"
                                style={{ width: 700 }}
                            >
                                <Spin spinning={this.state.loading} tip="Activating Membership...">
                                    {this.RenderRecords()}
                                </Spin>
                            </div>
                        </Col>
                    </Row>
                    {(this.props.record && this.props.notes) &&
                        <Row type="flex" align="middle" style={{ paddingBottom: 20, width: '100%' }}>
                            <Col>
                                <Tooltip placement="top" title="Update Notes">
                                    <Button 
                                        type='default' 
                                        value='notes' 
                                        onClick={() => this.updateNotes()}>
                                        {(this.props.notes_updating || this.props.activation_loading)
                                            ? <Icon type="loading" spin style={{ marginRight: 8 }} />
                                            : <Icon type="edit" style={{ fontWeight: 'bold', marginRight: 8 }} />}
                                        Update Notes
                                    </Button>
                                </Tooltip>
                            </Col>

                            <Col flex="auto" style={{ width: '34.2%' }}></Col>

                            <Col>
                                <Tooltip placement="top" title="Resend Email Confirmation">
                                    <Button
                                        type='primary'
                                        className='resendEmailBtn'
                                        onClick={this.handleResendEmail}
                                        disabled={!this.state.allAPIsLoaded}
                                    >
                                        {resending
                                            ? <Icon type="loading" spin style={{ marginRight: 8 }} />
                                            : <Icon type="mail" style={{ fontWeight: 900, marginRight: 8 }} />}
                                        {!this.state.allAPIsLoaded ? 'Loading...' : 'Resend Email Confirmation'}
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row>
                    }

                   <Modal
                        title="Select or Enter Email to Resend"
                        visible={emailModalVisible}
                        onOk={this.confirmEmailResend}
                        onCancel={this.cancelEmailModal}
                        okText="Send Email"
                        cancelText="Cancel"
                        okButtonProps={{ loading: resending }}
                        bodyStyle={{ padding: '20px 24px' }}
                        className="custom-modal-footer"
                    >
                        <Radio.Group
                            onChange={this.handleEmailChange}
                            value={selectedEmail}
                            className="custom-radio-group"
                        >
                            {this.state.modalEmails &&
                                this.state.modalEmails.map((e) => (
                                    <div key={e.id} style={{ marginBottom: 6 }}>
                                        <Radio value={e.email}>{e.email}</Radio>
                                    </div>
                                ))}

                            <div
                                style={{
                                    marginTop: 16,
                                    padding: '14px 16px',
                                    borderRadius: 8,
                                    background: selectedEmail === "manual" ? '#f6ffed' : '#fafafa',
                                    border: selectedEmail === "manual" ? '1px solid #52c41a' : '1px solid #f0f0f0',
                                    opacity: selectedEmail === "manual" ? 1 : 0.7,
                                    transition: 'all 0.3s',
                                }}
                            >
                                <Radio value="manual" style={{ fontWeight: 500 }}>
                                    Enter a manual email
                                </Radio>

                                <label
                                    style={{
                                        display: 'block',
                                        fontWeight: 500,
                                        color: '#555',
                                        marginTop: 10,
                                        marginBottom: 6,
                                    }}
                                >
                                    Enter manual email address:
                                </label>

                                <Input
                                    placeholder="Enter a valid email"
                                    value={this.state.manualEmail || ""}
                                    onChange={(e) =>
                                        this.setState({
                                            manualEmail: e.target.value,
                                            selectedEmail: "manual",
                                        })
                                    }
                                    disabled={selectedEmail !== "manual"}
                                    style={{
                                        borderRadius: 6,
                                        height: 38,
                                        border: '1px solid #d9d9d9',
                                        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
                                        backgroundColor: selectedEmail !== "manual" ? '#f5f5f5' : '#fff',
                                        cursor: selectedEmail !== "manual" ? 'not-allowed' : 'text',
                                        width: '300px',
                                    }}
                                />
                            </div>
                        </Radio.Group>
                    </Modal>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loading: state.membershiptoactivatereducer.loading,
        record: state.membershiptoactivatereducer.record,
        activation_loading: state.activateMembershipreducer.loading,
        activation_status: state.activateMembershipreducer.status,
        allstates: state.allstatesreducer.states,
        nesa_levels_loading: state.nesalevelsreducer.loading,
        nesa_levels: state.nesalevelsreducer.levels,
        saflevels_loading: state.saflevelsreducer.loading,
        saflevels: state.saflevelsreducer.levels,
        paymentrecords: state.membershiptransactionreducer.record,
        notes: state.regnotesreducer.notes,
        notes_updating: state.updatemembershipnotesreducer.loading,
        personProfile: state.alumniinforeducer.profileinfo
    }
}

function mapDispatchToProps(dispatch) {
    return { 
        sendNesaMail: (mailData) => dispatch(sendNesaMail(mailData)),
        actions: bindActionCreators(actions, dispatch) }
}

const ViewMembership = Form.create()(viewApplicationForm);

export default connect(mapStateToProps, mapDispatchToProps)(ViewMembership);


// WEBPACK FOOTER //
// ./src/components/Membership/ViewApplication.js